import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

export function formatDateTime(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function truncate(str, length = 50) {
    if (!str) return '';
    return str.length > length ? str.substring(0, length) + '...' : str;
}

export const CARGO_POLITICO_OPTIONS = [
    { value: 'vereador', label: 'Vereador' },
    { value: 'prefeito', label: 'Prefeito' },
    { value: 'deputado_estadual', label: 'Deputado Estadual' },
    { value: 'deputado_distrital', label: 'Deputado Distrital' },
    { value: 'deputado_federal', label: 'Deputado Federal' },
    { value: 'senador', label: 'Senador' },
    { value: 'governador', label: 'Governador' },
    { value: 'presidente', label: 'Presidente' },
];

export const OBJETIVO_OPTIONS = [
    { value: 'primeiro_mandato', label: 'Primeiro Mandato' },
    { value: 'reeleicao', label: 'Reeleição' },
];

export const ELEITOR_STATUS_OPTIONS = [
    { value: 'novo', label: 'Novo', color: 'bg-slate-100 text-slate-700' },
    { value: 'contato_inicial', label: 'Contato Inicial', color: 'bg-blue-100 text-blue-700' },
    { value: 'interessado', label: 'Interessado', color: 'bg-yellow-100 text-yellow-700' },
    { value: 'apoiador', label: 'Apoiador', color: 'bg-green-100 text-green-700' },
    { value: 'lideranca', label: 'Liderança', color: 'bg-purple-100 text-purple-700' },
    { value: 'inativo', label: 'Inativo', color: 'bg-red-100 text-red-700' },
];

export const ESTADOS_BRASIL = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
    'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
    'SP', 'SE', 'TO'
];

export function getStatusColor(status) {
    const option = ELEITOR_STATUS_OPTIONS.find(opt => opt.value === status);
    return option?.color || 'bg-slate-100 text-slate-700';
}

export function getStatusLabel(status) {
    const option = ELEITOR_STATUS_OPTIONS.find(opt => opt.value === status);
    return option?.label || status;
}
